import { ClockCircleOutlined, ProjectOutlined } from '@ant-design/icons';
import { BacklogCircle } from '../../../../assets/CustomIcons/BacklogCircle';
import { SprintIcon } from '../../../../assets/CustomIcons/SprintIcon';
import CustomTooltip from '../../../../components/UI/Tooltip/CustomTooltip';

export type MigrationStatusType = 'backlog' | 'planning' | 'sprint' | 'kanban';

const MigrationStatusComponentOptions = ['table', 'dropdown'] as const;

export type MigrationStatusComponentType = (typeof MigrationStatusComponentOptions)[number];

const ComponentTextWidthMap: { [x in MigrationStatusComponentType]: number } = {
  table: 80,
  dropdown: 125,
};

const MigrationStatusIconMap: { [x in MigrationStatusType]: JSX.Element } = {
  backlog: <BacklogCircle />,
  planning: <ClockCircleOutlined />,
  sprint: <SprintIcon />,
  kanban: <ProjectOutlined />,
};
export const MigrationStatusTextMap: { [x in MigrationStatusType]: string } = {
  backlog: 'Backlog',
  planning: 'Planning',
  sprint: 'Sprint',
  kanban: 'Kanban',
};
export const MigrationStatusColorMap: { [x in MigrationStatusType]: { text: string; background: string } } = {
  backlog: { text: 'text-neutral-900', background: 'bg-neutral-200' },
  planning: { text: 'text-blue-600', background: 'bg-blue-100' },
  sprint: { text: 'text-yellow-600', background: 'bg-yellow-100' },
  kanban: { text: 'text-orange-600', background: 'bg-orange-100' },
};

export type MigrationStatusLabelProps = {
  className?: string;
  migrationStatus: MigrationStatusType;
  component: MigrationStatusComponentType;
};

const MigrationStatusLabel: React.FC<MigrationStatusLabelProps> = (MigrationStatusProps) => {
  const maxWidth = ComponentTextWidthMap[MigrationStatusProps.component] || 80;

  const textStyle = {
    maxWidth: maxWidth,
  };

  const statusLabel = (
    <div
      className={`h-5 max-w-[225px] flex gap-1 items-center py-1 px-2 rounded text-sm font-normal  ${MigrationStatusColorMap[MigrationStatusProps.migrationStatus].background} ${MigrationStatusColorMap[MigrationStatusProps.migrationStatus].text} ${MigrationStatusProps.className || ''}`}
    >
      {MigrationStatusIconMap[MigrationStatusProps.migrationStatus]}
      <div style={textStyle} className={`h-5 whitespace-nowrap overflow-hidden text-ellipsis`}>
        {MigrationStatusTextMap[MigrationStatusProps.migrationStatus]}
      </div>
    </div>
  );

  if (MigrationStatusProps.component === 'dropdown' || maxWidth) {
    return statusLabel;
  }
  return (
    <CustomTooltip title={MigrationStatusTextMap[MigrationStatusProps.migrationStatus]}>{statusLabel}</CustomTooltip>
  );
};

export { MigrationStatusLabel };
